import { useMemo, useEffect } from "react"
import { getExperimentAssignment } from "common/lib/abTesting/experimentEngine"
import { experimentRegistry } from "common/lib/abTesting/experimentRegistry"
import { ExperimentContext } from "../types"

/**
 * React hook for A/B testing experiments.
 *
 * This hook:
 * - Determines which variant (if any) the user should see
 * - Automatically registers the experiment in the experiment registry
 */
export function useExperiment(
  experimentId: string,
  context: ExperimentContext = { isSignedIn: false },
) {
  // Get the experiment assignment (memoized based on experiment ID and login status)
  const assignment = useMemo(
    () => getExperimentAssignment(experimentId, context),
    [context, experimentId],
  )

  // Auto-register the experiment to the Experiment registry when a variant is assigned.
  useEffect(() => {
    if (assignment?.variantId) {
      experimentRegistry.registerExperiment({ experimentId, variantId: assignment.variantId })
    } else {
      experimentRegistry.clearExperiment()
    }
  }, [experimentId, assignment?.variantId])

  return {
    variantId: assignment?.variantId ?? null,
  }
}
